<template>
  <div class="login">
    <b-container>
      <h2 class="section-heading">Enter Code received on your phone</h2>
      <b-row>
        <b-col>
          <div class="login-card">
            <b-form v-if="canConfirm && !confSuccess">
              <!-- password -->
              <b-form-group
                label="Code"
              >
                <b-form-input
                  :class="{
                    'is-valid': !$v.code.$error && code,
                    'is-invalid': $v.code.$error && $v.code.$dirty
                  }"
                  v-model="$v.code.$model"
                  @input="(val) => (code = code.toUpperCase())"
                  type="text"
                ></b-form-input>
              </b-form-group>
             
              <b-form-group>
                <BtnMain @btnClicked="handleConfirm"
                  text="Confirm Code"
                  btnClass="confirm-btn"
                  variant="success"
                />
              </b-form-group>
            </b-form>
            <b-form-group v-if="confSuccess || confError">
                <b-alert
                  show
                  :variant="confSuccess ? 'success' : 'danger'"
                >
                  <p>{{ confMsg }}</p>
                </b-alert>
              </b-form-group>
            <!-- Error alert for unable to confirm -->
            <b-form-group v-if="!canConfirm">
                <b-alert
                  show
                  variant="danger"
                >
                  <p>{{ confMsg }}</p>
                </b-alert>
              </b-form-group>
              <p>Did not recieve a code? <a href="javascript:;"  @click="$router.push('registration-update')" target="_self"> Click here to update phone number</a></p>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { confirmPhoneRegistration } from '../services/api'
import BtnMain from '../components/BtnMain'
import { required } from 'vuelidate/lib/validators'
export default {
  components: {
    BtnMain
  },
  data () {
    return {
      code: '',
      confSuccess: false,
      confError: false,
      confMsg: '',
      canConfirm: true
    }
  },
  methods: {
    async handleConfirm () {
      this.$v.$touch()

      if (this.$v.code.$error) {
        return
      }

      const res = await confirmPhoneRegistration(localStorage.getItem('token'), this.code)
      if (res) {
        this.confError = false
        this.confSuccess = true
        window.scroll({
          top: 0,
          behavior: 'instant'
        })
        this.confMsg = 'Thank you for confirming your registration. You will now be logged in.'
        setTimeout(() => {
          this.$store.dispatch('authStore/loginWithToken', localStorage.getItem('token'), { root: true })
        }, 3000)
      } else {
        this.confError = true
        this.confMsg = 'There was an issue confirming your password, please try again later'
        setTimeout(() => {
          if (!this.confSuccess) {
            this.confError = false
            this.confMsg = ''
          }
        }, 5000)
      }
    }  
  },
  validations: {
    code: {
     
        required: required
    
    }
  }
}
</script>

<style scoped>

</style>